import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface VerifyAttributeData {
  emailAddress?: string;
  phoneNumber?: string;
  code?: string;
  aToken?: string;
  anonymousId?: string;
  session?: string;
  challengeId?: string;
}

// Define schema that matches VerifyAttributeResponse
const verifyAttributeResponseSchema = z.object({
  idToken: z.string().optional(),
  refreshToken: z.string().optional(),
  session: z.string().optional(),
  maskedEmailAddress: z.string().optional(),
  challenge: z.string().optional(),
  version: z.string().optional(),
  title: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  message: z.string().optional(),
  phoneLineNumber: z.string().optional(),
  temporary: z.boolean().optional(),
  challengeVerified: z.string().optional(),
});

// Extract type from schema
export type VerifyAttributeResponse = z.infer<
  typeof verifyAttributeResponseSchema
>;

export default async function fetchVerifyAttribute(
  lambdaUrl: string,
  data: VerifyAttributeData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(`${lambdaUrl}/verify-attribute`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return verifyAttributeResponseSchema.parse(result);
}
